<template>
  <div class="page-detail workorder-detail" v-loading="loading">
    <div class="title">工单详情</div>
    <div class="content">
      <div class="info-block">
        <div class="title">工单编号：{{ order.number }}</div>
        <div class="sub-info workorder-content">
          <div class="row">
            <div class="field">
              <div class="label">内容</div>
              <div class="text">{{ order.content }}</div>
            </div>
          </div>
          <div class="field">
            <div class="label">工单类型</div>
            <div class="text" :class="{ 'color-danger': +order.type > 3 }">
              {{ getNameOfWorkorderType(order.type) }}
            </div>
          </div>
          <div class="field">
            <div class="label">生成时间</div>
            <div class="text">
              {{
                Utils.dateFormat(
                  order.create_time && order.create_time.$date,
                  "YYYY-MM-DD HH:mm:ss"
                )
              }}
            </div>
          </div>
          <div class="field">
            <div class="label">当前状态</div>
            <div
              class="text"
              :class="{
                'color-warning': +order.status === 0,
                'color-danger': +order.status === 1,
                'color-success-light': +order.status === 2,
              }"
            >
              {{ getNameOfWorkorderStatus(order.status) }}
            </div>
          </div>
          <div class="field">
            <div class="label">办结时间</div>
            <div class="text">
              {{
                Utils.dateFormat(
                  order.finish_time && order.finish_time.$date,
                  "YYYY-MM-DD HH:mm:ss"
                )
              }}
            </div>
          </div>
          <div class="field">
            <div class="label">话务员</div>
            <div class="text">{{ order.handler_name }}</div>
          </div>

          <div class="field">
            <div class="label">受理时长</div>
            <div class="text">{{ order.time }}</div>
          </div>
          <div class="field">
            <div class="label">办结通话结果</div>
            <div class="text">{{ order.handled_result }}</div>
          </div>
          <div class="field">
            <div class="label">办结备注</div>
            <div class="text">{{ order.handled_remark }}</div>
          </div>
          <div class="actions">
            <el-button
              type="success"
              size="small"
              @click="accept()"
              v-if="+order.status < 2"
              >受理</el-button
            >
            <el-button
              type="success"
              size="small"
              @click="handleClose()"
              v-if="+order.status === 2"
              >办结</el-button
            >
            <!-- <el-button
              v-if="+order.status === 2"
              @click="close"
              type="info"
              size="small"
              >关闭</el-button
            > -->
            <!--<div>-->
            <!-- <el-button type="info" size="small">转交</el-button> -->
            <!--</div>-->
          </div>
        </div>
      </div>

      <div class="row sec">
        <div class="info-block service-target">
          <div class="title">服务对象信息</div>
          <div class="sub-info">
            <div class="field">
              <div class="text">
                <div class="field">
                  <div class="label">姓名</div>
                  <div class="text">{{ info.name }}</div>
                </div>
                <div class="field">
                  <div class="label">手机号</div>
                  <div class="text">
                    {{ info.phone
                    }}<i
                      v-if="+order.status === 2"
                      class="el-icon-phone-outline"
                      @click="callSomeone(info.phone)"
                    ></i>
                  </div>
                </div>
                <div class="field">
                  <div class="label">身份证</div>
                  <div class="text">{{ info.idCard }}</div>
                </div>
                <div class="field">
                  <div class="label">年龄</div>
                  <div class="text">{{ info.age }}</div>
                </div>
                <div class="field">
                  <div class="label">性别</div>
                  <div class="text">{{ info.gender | sexFilter }}</div>
                </div>
                <div class="field">
                  <div class="label">老人类型</div>
                  <div class="text">{{ getNameOfOldManType(info.type) }}</div>
                </div>
                <div class="field">
                  <div class="label">地址</div>
                  <div class="text">{{ info.residenceAddress }}</div>
                </div>
                <div class="field">
                  <div class="label">标签</div>
                  <div class="text">{{ info.tagNames }}</div>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="label">子女信息</div>
              <div class="text">
                <div class="field" v-for="item in contacts" :key="item.Gid">
                  <div class="label">{{ item.name }}</div>
                  <div class="text">
                    <span>{{ item.relationship }}</span>
                    <span
                      >{{ item.phone
                      }}<i
                        v-if="+order.status === 2"
                        class="el-icon-phone-outline"
                        @click="callSomeone(item.phone)"
                      ></i
                    ></span>
                  </div>
                </div>
                <div class="field" v-if="contacts.length === 0">
                  <div class="label"></div>
                  <div class="text color-gray">无相关信息</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="info-block order-histories">
          <div class="title">历史工单</div>
          <div class="sub-info">
            <table>
              <tbody>
                <tr v-for="item in histories" :key="item._id.$oid">
                  <td>{{ item.number }}</td>
                  <td>
                    {{
                      Utils.dateFormat(
                        item.create_time && item.create_time.$date,
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    }}
                  </td>
                  <td>{{ getNameOfWorkorderType(item.type) }}</td>
                  <td>{{ getNameOfWorkorderStatus(item.status) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <Map
              ref="theMap"
              :olderGid="order.user_id"
              :date="order.create_time.$date"
            ></Map>
          </div>
        </div>
      </div>

      <div class="info-block">
        <div class="title">工单处理记录</div>
        <div class="sub-info">
          <div class="info-block-inner" v-if="+order.status === 2">
            <div class="title">添加处理记录</div>
            <div class="content form1">
              <el-input type="textarea" v-model="records" rows="4"></el-input>
              <el-button type="primary" size="small" @click="addRecord"
                >提交</el-button
              >
            </div>
          </div>
          <div class="info-block-inner">
            <div class="title">工单处理历史</div>
            <div class="content histories">
              <div class="his-item" v-for="item in list" :key="item.id">
                <div v-if="item.type === 1" class="operation">
                  <div class="field">
                    <div class="label">操作日期</div>
                    <div class="text">
                      {{
                        Utils.dateFormat(item.createTime, "YYYY-MM-DD HH:mm:ss")
                      }}
                    </div>
                  </div>
                  <div class="field">
                    <div class="label">操作类型</div>
                    <div class="text">
                      {{ getNameOfWorkorderOperationType(item.oper_type) }}
                    </div>
                  </div>
                  <div class="field">
                    <div class="label">操作内容</div>
                    <div class="text">{{ item.content }}</div>
                  </div>
                </div>
                <div v-else class="record">
                  <div class="field">
                    <div class="label">坐席名称</div>
                    <div class="text">{{ item.agentName }}</div>
                  </div>
                  <div class="field">
                    <div class="label">坐席分机号</div>
                    <div class="text"></div>
                  </div>
                  <div class="field">
                    <div class="label"></div>
                    <div class="text"></div>
                  </div>
                  <div class="field">
                    <div class="label">记录创建时间</div>
                    <div class="text">
                      {{
                        Utils.dateFormat(item.createTime, "YYYY-MM-DD HH:mm:ss")
                      }}
                    </div>
                  </div>
                  <div class="field">
                    <div class="label">通话开始时间</div>
                    <div class="text">
                      {{
                        Utils.dateFormat(item.createTime, "YYYY-MM-DD HH:mm:ss")
                      }}
                    </div>
                  </div>
                  <div class="field">
                    <div class="label">通话结束时间</div>
                    <div class="text">
                      {{
                        Utils.dateFormat(item.endDate, "YYYY-MM-DD HH:mm:ss")
                      }}
                    </div>
                  </div>
                  <div class="field">
                    <div class="label">主叫号码</div>
                    <div class="text">
                      {{ item.caller
                      }}<i
                        v-if="+order.status === 2"
                        class="el-icon-phone-outline"
                        @click="callSomeone(item.caller)"
                      ></i>
                    </div>
                  </div>
                  <div class="field">
                    <div class="label">被叫号码</div>
                    <div class="text">
                      {{ item.callee
                      }}<i
                        v-if="+order.status === 2"
                        class="el-icon-phone-outline"
                        @click="callSomeone(item.callee)"
                      ></i>
                    </div>
                  </div>
                  <div class="field">
                    <div class="label">响铃时长</div>
                    <div class="text">
                      {{
                        +item.dialDuration &&
                        Utils.formatTime(+item.dialDuration * 1000)
                      }}
                    </div>
                  </div>
                  <div class="field">
                    <div class="label">通话时长</div>
                    <div class="text">
                      {{
                        +item.talkDuration &&
                        Utils.formatTime(+item.talkDuration * 1000)
                      }}
                    </div>
                  </div>
                  <div class="field">
                    <div class="label">通话状态</div>
                    <div class="text"></div>
                  </div>
                  <div class="field">
                    <div class="label"></div>
                    <div class="text"></div>
                  </div>
                  <div class="row">
                    <div class="field">
                      <div class="label">通话录音</div>
                      <div class="text">
                        <div class="record-player"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import qs from 'qs'
import Map from "@/components/common/map.vue";
import { alarmorderApi, orderCallRecordApi } from "@/services/all-api.js"
export default {
  data() {
    return {
      order: {
        status: 0
      },
      info: {},
      contacts: [],
      histories: [],
      list: [],
      records: '',
      loading: false
    }
  },
  components: {
    Map
  },
  mounted() {
    this.loadData()
  },
  computed: {
    oid() {
      return this.$route.query.oid
    }
  },
  watch: {
    '$route'() {
      this.loadData()
    }
  },
  methods: {
    addRecord() {
      if (!this.records) {
        this.$message.error('请输入处理记录')
        return
      }
      this.loading = true
      this.Service.call('workorderrecord/remark', 'POST', qs.stringify({
        workOrderId: this.oid,
        content: this.records
      }), null, null, null, 'application/x-www-form-urlencoded').then(() => {
        this.$message.success('工单备注成功')
        this.loadData()
      }).catch(() => {
        this.loading = false
      })
    },
    accept() {
      this.$confirm('确定执行【受理】操作吗？').then(() => {
        this.loading = true
        alarmorderApi.accept({ id: this.oid }).then((res) => {
          if (res.code === 0) {
            this.$message.success('工单受理成功')
            this.loadData()
          } else {
            this.$message.error(`受理失败:${res.des || ""}`);
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    handleClose() {
      this.modal('AlarmorderHandleModal', this.oid).promise.then(data => {
        if (data === true) {
          this.loadData()
        }
      })
    },
    close() {
      this.$confirm('确定关闭此工单吗？').then(() => {
        this.loading = true
        alarmorderApi.handleClose({ id: this.oid }).then(() => {
          this.$message.success('工单关闭成功')
          this.loadData()
        }).catch(() => {
          this.loading = false
        })
      })
    },
    loadData() {
      if (!this.oid) {
        this.routeBack()
        return
      }
      this.records = ''
      this.loading = true
      this.Service.call('workorder/detail', 'GET', { id: this.oid }).then(data => {
        let t = "--"
        if (data.finish_time && data.finish_time.$date) {
          t = data.finish_time.$date - data.create_time.$date
        }
        this.order = { ...data, time: this.Utils.formatTime(t) }
        let task = []
        let records = []
        let histories = []
        //老人详情
        task.push(this.Service.call('theold/detail', 'GET', { gid: data.user_id }).then(data => {
          this.info = data || {}
        }).catch(() => { }))
        //老人联系人
        task.push(this.Service.call('usercontact', 'GET', { gid: data.user_id }).then(data => {
          this.contacts = data || []
        }).catch(() => { }))
        //老人历史工单
        task.push(this.Service.call('workorder', 'GET', { index: 0, size: 5, userId: data.user_id }).then(data => {
          this.histories = data.data || []
        }).catch(() => { }))
        //处理记录
        task.push(this.Service.call('CallRecords', 'GET', { workOrderId: this.oid }).then(data => {
          _.forEach(data, e => {
            e.createTime = new Date(e.startDate)
            e.id = e.contantId
            e.type = 2
          })
          records = data
        }).catch(() => { }))
        task.push(this.Service.call('workorderrecord/byWorkOrderId', 'GET', { workOrderId: this.oid }).then(data => {
          _.forEach(data, e => {
            e.createTime = e.create_time && e.create_time.$date ? new Date(e.create_time.$date) : new Date()
            e.id = e._id && e._id.$oid || Math.random()
            e.type = 1
          })
          histories = data
        }).catch(() => { }))
        Promise.all(task).finally(() => {
          this.loading = false
          this.list = _.chain([]).concat(records, histories).orderBy(['createTime'], ['desc']).value()
        })
      }).catch(() => {
        this.loading = false
      })
    },
    callSomeone(phone) {
      this.$store.commit("setWant2call", phone);
      this.$store.commit("setCallReason", JSON.stringify({ reason: 'alarmorder', gid: this.oid }));
      this.routeTo("/dashboard");
    }
  }
}
</script>
<style lang="scss" scoped>
.el-icon-phone-outline {
  color: #409efe;
  font-size: 18px;
  margin-left: 3px;
}
</style>